const searchTrigger = document.querySelector('[data-search-trigger]')

const init = () => {

	if (searchTrigger !== null) {

		searchTrigger.addEventListener('click', handleTriggerClick)

	}

}

const handleTriggerClick = (e) => {

	e.target.dispatchEvent(new Event('search-triggered', {
		bubbles: true
	}))

}

export default init